var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import styled from '@emotion/styled';
import { fontSize } from 'styled-system';
import { themeWidth, themeMaxWidth, themeHeight, themeMaxHeight, stroke, fill, } from '../../../common/theme/system-utilities';
import themedComponent from '../../../common/components/hoc/themedComponent';
import Icon from '../../../common/components/Icon';
var ICON_SIZE = ['sp_32', 'sp_40', 'sp_32'];
var PAYBACK_ICON_SIZE = 'sp_24';
var StyledIcon = styled(Icon)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), fontSize, themeWidth, themeMaxWidth, themeHeight, themeMaxHeight);
StyledIcon.defaultProps = {
    alt: '',
    role: 'presentation',
    fontSize: 0,
    themeWidth: ICON_SIZE,
    themeMaxWidth: ICON_SIZE,
    themeHeight: ICON_SIZE,
    themeMaxHeight: ICON_SIZE,
};
var WishlistIcon = styled(StyledIcon)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n  ", ";\n"], ["\n  ", "\n  ", ";\n"])), fill, stroke);
WishlistIcon.defaultProps = __assign(__assign({}, StyledIcon.defaultProps), { fill: 'none', stroke: 'gray.9' });
export var Account = themedComponent(function () { return React.createElement(StyledIcon, { name: "accountH24" }); }, function () { return React.createElement(StyledIcon, { name: "accountFfh" }); });
export var Wishlist = function (props) { return React.createElement(WishlistIcon, __assign({ name: "wishlist" }, props)); };
export var Cart = themedComponent(function () { return React.createElement(StyledIcon, { name: "cartH24" }); }, function () { return React.createElement(StyledIcon, { name: "cartFfh" }); });
export var Payback = function (props) { return (React.createElement(StyledIcon, __assign({ name: "paybackShort", themeMaxWidth: PAYBACK_ICON_SIZE, themeMaxHeight: PAYBACK_ICON_SIZE, themeHeight: PAYBACK_ICON_SIZE, themeWidth: PAYBACK_ICON_SIZE }, props))); };
var templateObject_1, templateObject_2;
